<template>
  <div class="t1">
    <div class="nav">
      <nav_list></nav_list>
    </div>
    <div class="body">
      <sidebar def="/coupon"></sidebar>
      <div class="t2">
        <breadcrumb cls="coupon"></breadcrumb>

        <div class="topad">
          <el-input class="ipt" v-model="sn" :placeholder="$lang(50046)"></el-input>
          <el-button type="success" @click="get_coupon" icon="el-icon-check" circle></el-button>
        </div>
        <div class="list" v-if="list.data.length">
          <div class="t3">
            <div class="coupon-container">
              <div class="coupon-card" v-for="(itm, i) in list.data" :key="i" v-if="itm.coupon">
                <div class="coupon-left">
                  <div class="coupon-amount">{{itm.coupon.strs.tit}}</div>
                  <div class="coupon-code">SN: {{itm.sn}}</div>
                </div>
                <div class="coupon-right">
                  <div class="coupon-validity">
                    <span class="label">{{$lang(50051)}}</span>
                    <span class="value">{{itm.coupon.start_time}} - {{itm.coupon.end_time}}</span>
                  </div>
                  <div class="coupon-received">
                    <span class="label">{{$lang(50052)}}</span>
                    <span class="value">{{itm.receive_time}}</span>
                  </div>
                  <div class="coupon-status">
                    <span class="label">{{$lang(50053)}}</span>
                    <span class="status-tag" :class="{'status-valid': itm.status == 1 && itm.coupon.status == 0}">
                      <span v-if="itm.status == 1 && itm.coupon.status == 0">{{c(52289)}}</span>
                      <span v-else>{{itm.status_str}}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="pagination-wrapper">
              <el-pagination 
                background 
                layout="prev, pager, next" 
                :current-page="list.current_page"
                :page-size="list.per_page" 
                :total="list.total" 
                @current-change="change_page">
              </el-pagination>
            </div>
          </div>
        </div>
        <el-empty :description="$lang(49599)" v-else></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import sidebar from '../index/sidebar.vue';
import breadcrumb from '../index/breadcrumb.vue';
import nav_list from '../index/nav_list.vue';

export default {
  name: "bus_list",
  components: {
    sidebar,
    breadcrumb,
    nav_list,
  },
  data() {
    return {
      a: 'bus_list',
      list: [],
      page: 1,
      s: -1,
      path: '',
      sn: '',
    };
  },
  mounted(e) {
    if (this.$route.query.s || this.$route.query.s == 0) {
      this.s = this.$route.query.s
      this.path = '/bus_list?s=' + this.s
    } else {
      this.path = '/bus_list'
    }
    document.title = this.web_tit;
    this.f5()
  },
  methods: {
    change_page(e) {
      this.page = e
      this.f5()
    },
    f5() {
      this.get("/user/coupon_list", { page: this.page }).then((e) => {
        this.list = e.list
        this.page = e.list.current_page
      });
    },
    get_coupon() {
      if (!this.sn) return;
      this.get("/user/get_coupon", { sn: this.sn }).then((e) => {
        this.list = []
        this.page = 1
        this.f5()
      });
    },
  }
}
</script>

<style scoped>
.body { 
  display: flex;
}
.t1 .t2 .topad {
  width: 80%;
  max-width: 1200px;
  margin: 1%;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.t2 {
  width: 100%;
 
}
.t1 .t2 .topad .ipt {
  width: 300px;
  margin-right: 15px;
}

.t1 .t2 .list {
  width: 80%;
  max-width: 1200px;
  margin: 1%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  padding: 20px;
}

.coupon-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 10px;
}

.coupon-card {
  display: flex;
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  position: relative;
  transition: transform 0.3s ease;
}

.coupon-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.coupon-card::before,
.coupon-card::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.coupon-card::before {
  left: -6px;
  box-shadow: inset -2px 0 4px rgba(0,0,0,0.1);
}

.coupon-card::after {
  right: -6px;
  box-shadow: inset 2px 0 4px rgba(0,0,0,0.1);
}

.coupon-left {
  width: 35%;
  padding: 20px;
  background: linear-gradient(135deg, #409EFF 0%, #3a8ee6 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.coupon-amount {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}

.coupon-code {
  font-size: 12px;
  opacity: 0.9;
  word-break: break-all;
  text-align: center;
}

.coupon-right {
  flex: 1;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.coupon-validity,
.coupon-received,
.coupon-status {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label {
  color: #909399;
  font-size: 12px;
}

.value {
  color: #606266;
  font-size: 13px;
}

.status-tag {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  background: #f5f7fa;
  color: #909399;
  font-size: 12px;
}

.status-valid {
  background: #f0f9eb;
  color: #67c23a;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}

.el-button--success {
  background: linear-gradient(135deg, #67C23A, #5daf34);
  border: none;
  padding: 12px;
}

.el-button--success:hover {
  background: linear-gradient(135deg, #5daf34, #529b2e);
  transform: translateY(-1px);
}

.el-input__inner {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s;
}

.el-input__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64,158,255,0.2);
}
</style>



// WEBPACK FOOTER //
// src/pages/user/coupon.vue